import config from './config'
import _ from 'lodash'
import Backbone from 'backbone'

// a count of how many currencies use a given currency symbol keyed by currency
// symbol
var symbolCounts = {}

// a hash of currencies by code
var byCode

/**
 * @typedef Currency
 * @property {String} code the 3 letter ISO currency code (e.g. USD, EUR)
 * @property {String} symbol the currency symbol (e.g. $, or €)
 * @property {String} description the currency description (e.g. "United States
 * Dollar", "Euro")
 */

var currency = {

	/**
	 * Returns the currency with the given coe
	 * @param {String} code
	 * @returns {Currency}
	 */
	forCode: function (code) {
		if (!byCode) {
			byCode = _.keyBy(config.currencies, 'code')
		}

		code = code || config.defaultCurrencyCode

		return byCode[code]
	},

	/**
	 * Returns all currencies
	 * @returns {Currency[]}
	 */
	all: function () {
		return config.currencies
	},

	// returns whether the currency code should be included in the display of the
	// currency with the given code
	useCode: function(code) {
		var c = this.forCode(code)
		return !c || symbolCounts[c.symbol] > 1
	},

	update: function(currencies) {
		config.update({ currencies: currencies })
		for (var code in symbolCounts) {
			delete symbolCounts[code]
		}
		_.extend(symbolCounts, _.countBy(currencies, function(currency) {
			return currency.symbol
		}))
		// #53702 reset the default currency code if it's been changed
		// #54155 note that currencies could be null, particularly if there are
		// no databases defined yet
		if (!_.includes(currencies, this.forCode(config.defaultCurrencyCode))) {
			config.defaultCurrencyCode = _.head(currencies)?.code
		}
		// #10837 make sure newly added currencies appear
		byCode = null
	},

	/**
	 * Returns a label for a currency which is appropriate to display to an
	 * end user
	 * @param {Currency|String} c the currency or currency code
	 */
	label: function(c) {
		if (c) {
			c = c.code ? c : this.forCode(c)
			return c.symbol + ' - ' + c.description + ' (' + c.code + ')'
		} else {
			return ''
		}
	},

	/**
	 * @returns {Object<String,String>} a label for each currency which is
	 * appropriate to display to an end user, keyed by currency code
	 */
	labelsByCode: function() {
		let labelsByCode = {}
		_.each(this.all(), cur => labelsByCode[cur.code] = this.label(cur))
		return labelsByCode
	}

}

Backbone.on('load', function(data) {
	if (data.config) {
		currency.update(data.config.currencies)
	}
})

currency.symbolCounts = symbolCounts

export default currency
export { symbolCounts }

currency.__filename__ = 'components/currency.js'
